import { useState } from "react";
import axios from "axios";
import { X } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errorText = (d) => typeof d === "string" ? d : Array.isArray(d) ? "A nova senha deve ter pelo menos 6 caracteres." : "Não foi possível alterar a senha.";

export const PasswordModal = ({ onClose }) => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return setError("A confirmação não confere com a nova senha.");
    setSaving(true); setError("");
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: form.current_password, new_password: form.new_password }, { withCredentials: true });
      toast.success("Senha alterada com sucesso");
      onClose();
    } catch (err) { setError(errorText(err.response?.data?.detail)); } finally { setSaving(false); }
  };
  const field = (key, label, testid) => <label>{label}<input data-testid={testid} type="password" required minLength={key === "current_password" ? 1 : 6} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} /></label>;
  return <div className="modal-backdrop"><div className="modal small-modal" data-testid="password-modal">
    <button data-testid="password-modal-close-button" className="icon-btn close" onClick={onClose}><X /></button>
    <p className="eyebrow">SEGURANÇA</p><h2>Alterar senha</h2>
    <form onSubmit={submit}>
      {field("current_password", "Senha atual", "password-current-input")}
      {field("new_password", "Nova senha (mín. 6 caracteres)", "password-new-input")}
      {field("confirm", "Confirmar nova senha", "password-confirm-input")}
      {error && <div data-testid="password-error" className="error">{error}</div>}
      <button data-testid="password-save-button" className="primary-btn" disabled={saving}>{saving ? "Salvando..." : "Salvar nova senha"}</button>
    </form>
  </div></div>;
};
